import React from 'react'
import PropTypes from 'prop-types'
import Shipment from '../../../../containers/main/EditOrders/Shipment'
import Client from '../../../../containers/main/EditOrders/Client'
import Payment from '../../../../containers/main/EditOrders/Payment'
const StepSection = ({ activeStep }) => {
  return (
    <>
      <div
        className={[
          'col-container',
          'col-left-container',
          activeStep === 0 ? 'active' : '',
        ].join(' ')}
      >
        <Shipment />
      </div>
      <div
        className={[
          'col-container',
          'col-left-container',
          activeStep === 1 ? 'active' : '',
        ].join(' ')}
      >
        <Client />
      </div>

      <div
        className={[
          'col-container',
          'col-left-container',
          activeStep === 2 ? 'active' : '',
        ].join(' ')}
      >
        <Payment />
      </div>
    </>
  )
}
StepSection.propTypes = {
  activeStep: PropTypes.number,
}
export default StepSection
